import React from "react";
import { FormFeedback } from "reactstrap";

const UserDropdown = ({
  input,
  label,
  className,
  options,
  placeholder,
  required,
  readonly,
  onChange,
  onClick,
  meta: { touched, error },
}) => {
  let isError = touched && typeof error !== "undefined";

  let handleChange = (e) => {
    if (readonly) {
      return;
    }
    input.onChange(e);
  };

  let requiredSpan = required && <span className="required">*</span>;
  const selectClass =
    className + " form-control" + (isError ? " is-invalid" : "");

  return (
    <div>
      {label && (
        <label>
          {label} {requiredSpan}
        </label>
      )}
      <div className="select_box">
        <select
          name={input.name}
          className={selectClass}
          value={input.value}
          onChange={handleChange}
          onClick={onClick}
          readOnly={readonly}
          style={{ wordBreak: "break-word" }}
        >
          {options &&
            options.map((option, i) => {
              if (typeof option.optGroup !== "undefined") {
                return <optgroup key={i} label={option.optGroup} />;
              }

              return (
                <option
                  key={i}
                  value={option.value}
                  style={{
                    marginTop: "10px",
                    marginBottom: "10px",
                    wordBreak: "break-word",
                  }}
                >
                  {option.label}
                </option>
              );
            })}
        </select>
      </div>
      {isError && <FormFeedback>{error}</FormFeedback>}
    </div>
  );
};

export default UserDropdown;



// WEBPACK FOOTER //
// ./src/components/UserDropdown.js